import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

// Font Awesome

// Appt Components
import Box from '../../../components/simple/box/Box'
import DataTable from '../../../components/simple/dataTable/DataTable.js'
import Text from '../../../components/simple/text/Text'
import Divider from '../../../components/simple/divider/Divider'

// Services
import LocalStorageService from '../../../services/LocalStorageService'
import { capitalize } from '../../../utils/text.js'

import moment from 'moment'
import Anchor from '../../../components/simple/anchor/Anchor.js'
import ActionButton from '../../../components/compound/actionButton/ActionButton.js'

const RelatedConcerns = (props) => {
  const apiToken = LocalStorageService.get('apiToken')
  const activeOrg = LocalStorageService.get('activeOrg')
    const terms = LocalStorageService.get('terms');

  const [submissions, setSubmissions] = useState([])
  const [responses, setResponses] = useState([])

  const navigate = useNavigate()

  const [sort, setSort] = useState({
      property: 'id',
      direction: 'desc'
    })

  let suTerm = capitalize(terms?.serviceUser || 'Service User')

  const resultColumns = [
    // {
    //   property: 'id',
    //   label: 'Concern No',
    //   header: <Text>Concern No</Text>,
    //   render: datum => (
    //     <Text>besmart: {JSON.stringify(datum)}</Text>
    //   )
    // },
     {
      property: 'concernDate',
      label: 'Child',
      header: <Text>Date</Text>,
      render: datum => (
        <Text>{datum.concernDate || ''} {datum.concernTime || ''}</Text>
      )
    },
    {
      property: 'user',
      label: 'Child',
      header: <Text>{suTerm}</Text>,
      render: datum => (
        <Anchor href={`/serviceuser/${datum.userId}/edit`} color='primary'>
          <Text>{datum.firstname || ''} {datum.lastname || ''}</Text>
        </Anchor>
      )
    },
      {
      property: 'studentGroup',
      label: suTerm + ' Group',
      header: <Text>{suTerm} Group</Text>
    },
    {
      property: 'concern',
      label: 'Communication',
      header: <Text>Communication</Text>,
       render: datum => (
        <Text>{datum.concern || ''}</Text>
      )
    },

    {
      property: 'type',
      label: 'Type',
      header: <Text>Type</Text>,
       render: datum => (
        <Text>{datum.positiveNegative || ''}</Text>
      )
    },


    {
      property: 'action',
      label: 'Action',
      header: <Text>Action </Text>,
       render: datum => (
        <Text>{datum.action || ''}</Text>
      )
    },
    {
      property: 'actionDate',
      label: 'Action Date',
      header: <Text>Action Date </Text>,
       render: datum => (
        <Text>{datum.actionDate || ''} {datum.actionTime || ''}</Text>
      )
    },
  ]

  const [showIncidents, setShowIncidents] = useState(false)

  const downloadCSV = () => {
    const csvRows = []
    const submissions = props.results || []

    let suTerm = capitalize(terms?.serviceUser || 'Service User')

    const headers = [
      'Date',
      'Child',
      'Student Group',
      'Concern',
      'Type',
      'Action',
      'Action Date'
    ]
    csvRows.push(headers.join(','))

    submissions.forEach(datum => {
      let row = [
        `${datum.concernDate || ''} ${datum.concernTime || ''}`,
        `${datum.firstname || ''} ${datum.lastname || ''}`,
        `${datum.studentGroup || ''}`,
        `${datum.concern || ''}`,
        `${datum.positiveNegative || ''}`,
        `${datum.action || ''}`,
        `${datum.actionDate || ''} ${datum.actionTime || ''}`
      ]

      // escape quotes by doubling them, then wrap in quotes to preserve commas and line breaks
      row = row.map(item => `"${item.replace(/"/g, '""')}"`)

      csvRows.push(row.join(','))
    })

    const csvString = csvRows.join('\n')
    const blob = new Blob([csvString], { type: 'text/csv' })
    const url = URL.createObjectURL(blob)
    // window.open(url, '_blank')

    let fileLink = document.createElement('a');
        fileLink.href = url;
        fileLink.download = 'BeSmart - Related Communications - ' + moment().format('DD-MM-YYYY') + '.csv';
        fileLink.click();

  }


  return (
    <Box background='white' direction='column' gap='small' round='small' margin={{ top: 'small', bottom: 'small'}}>
         <Box
            gap='small'
            margin={{ horizontal: 'small' }}
            pad={{ horizontal: 'xsmall', top: 'none' }}
            round='small'
        >

            <Box direction='row' justify='between' margin={{ top: 'medium', bottom: 'medium' }}>
                <Text margin={{ top: 'small', bottom: 'small' }} size='xlarge'>Additional Actions</Text>
                <Box alignSelf='center' direction='row' gap='none'>
                    <ActionButton size='small' onClick={() => {
                      setShowIncidents(!showIncidents)
                    }} label={showIncidents ? 'Hide Related Communications' : 'Show Related Communications'} primary />
                    <ActionButton size='small' onClick={() => { downloadCSV() }} label='Download CSV' primary />
                    {props?.additionalButtons}
                </Box>

            </Box>
            {showIncidents && <>
                <Divider />
                <Box direction='column' gap='xsmall' margin={{ top: 'none' }}>
                        <Text margin={{ top: 'small', bottom: 'small' }} size='xlarge'>Related Communications</Text>

                        <Text margin={{ top: 'small', bottom: 'small' }} size='medium'>First 250 Results ({props.results?.length || 0} found)</Text>
                        {props.results?.length > 0 && <DataTable
                            columns={resultColumns}
                            data={props.results}
                            primaryKey='id'
                            sort={sort}
                            onSort={setSort}
                        />}
                        {!props.results?.length > 0 && <Text color='#666'>- No results to display -</Text>}

                </Box>
            </>}
        </Box>
    </Box>
  )
}

export default RelatedConcerns
